import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { AI_UNCONFIGURED } from "../ai/api";
import type { AiCapabilityState } from "../ai/hooks";
import { staffApi } from "./api";

/**
 * Staff operational investigations always use the platform's own routing.
 * Organization enablement and BYOK state are intentionally irrelevant here.
 */
export function usePlatformAiCapability(): AiCapabilityState {
  const q = useQuery({
    queryKey: ["staff", "platform-ai-capability"],
    queryFn: () => staffApi.platformAiCapability(),
    staleTime: 60_000,
    retry: false,
  });
  const configured = q.data ? q.data.available : true;
  return useMemo(
    () => ({
      available: configured,
      settled: !q.isPending,
      known: !!q.data,
      reason: configured ? undefined : "platform_unconfigured",
      creditsAvailable: true,
      hint: configured ? "" : AI_UNCONFIGURED,
      detail: configured ? "" : "A platform admin can connect and route a provider under AI administration.",
      blocked: !configured,
      titleFor: (own?: string) => (configured ? own : AI_UNCONFIGURED),
    }),
    [configured, q.isPending, q.data],
  );
}
